import clsx from 'clsx';
import { useContador } from '../hooks/use-contador';

type NumeroProps = {
  valor: number;
  duracaoMs?: number;
  prefixo?: string;
  sufixo?: string;
  className?: string;
};

/**
 * Número que conta de 0 até `valor` ao entrar na viewport (ver `useContador`
 * para o guard de movimento reduzido / ambiente sem `IntersectionObserver`).
 * `tabular-nums` para os dígitos não dançarem de largura durante a contagem.
 */
export function Numero({
  valor,
  duracaoMs,
  prefixo = '',
  sufixo = '',
  className,
}: NumeroProps): JSX.Element {
  const { ref, valor: exibido } = useContador<HTMLSpanElement>(valor, duracaoMs);

  return (
    <span ref={ref} className={clsx('font-semibold tabular-nums', className)}>
      {prefixo}
      {exibido}
      {sufixo}
    </span>
  );
}
